if (!customElements.get('wlsn-info-modal')) {
  class WLSNInfoModal extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        open: 'is-open',
        bodyLockClass: 'body-lock',
        trigger: 'js-wlsn-info-modal-trigger',
        close: 'js-wlsn-info-modal-close',
        wrapper: 'js-wlsn-info-modal-wrapper'
      };

      this.elements = {
        wrapper: this.querySelector(`.${this.classes.wrapper}`),
        closeBtn: this.querySelector(`.${this.classes.close}`)
      };

      // Optional: a trigger with data-modal-id only opens the modal with the matching ID.
      this.modalId = this.dataset.modalId;

      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleSectionSelect = this.handleSectionSelect.bind(this);
      this.handleSectionDeselect = this.handleSectionDeselect.bind(this);
    }

    connectedCallback() {
      // Delegated so triggers rendered later (drawers, AJAX content) also work.
      document.addEventListener('click', this.handleTriggerClick);

      if (this.elements.closeBtn) {
        this.elements.closeBtn.addEventListener('click', this.handleCloseClick);
      }

      this.addEventListener('click', this.handleOutsideClick);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:section:deselect', this.handleSectionDeselect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleTriggerClick);
      document.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.handleSectionDeselect);

      if (this.elements.closeBtn) {
        this.elements.closeBtn.removeEventListener('click', this.handleCloseClick);
      }

      this.removeEventListener('click', this.handleOutsideClick);
      document.body.classList.remove(this.classes.bodyLockClass);
    }

    handleTriggerClick(event) {
      const trigger = event.target.closest(`.${this.classes.trigger}`);

      if (!trigger) return;

      const targetId = trigger.dataset.modalId;
      if (targetId && targetId !== this.modalId) return;

      event.preventDefault();
      this.lastTrigger = trigger;
      this.open();
    }

    handleCloseClick() {
      this.close();
    }

    handleOutsideClick(event) {
      if (!this.elements.wrapper.contains(event.target)) {
        this.close();
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    // Keep the modal visible while its section is being edited in the theme editor.
    handleSectionSelect(event) {
      if (this.closest('.shopify-section')?.id === `shopify-section-${event.detail.sectionId}`) {
        this.open();
      }
    }

    handleSectionDeselect(event) {
      if (this.closest('.shopify-section')?.id === `shopify-section-${event.detail.sectionId}`) {
        this.close();
      }
    }

    open() {
      this.classList.add(this.classes.open);
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add(this.classes.bodyLockClass);
      document.addEventListener('keydown', this.handleKeydown);

      if (this.elements.closeBtn) {
        this.elements.closeBtn.focus({ preventScroll: true });
      }
    }

    close() {
      if (!this.classList.contains(this.classes.open)) return;

      this.classList.remove(this.classes.open);
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(this.classes.bodyLockClass);
      document.removeEventListener('keydown', this.handleKeydown);

      if (this.lastTrigger) {
        this.lastTrigger.focus({ preventScroll: true });
        this.lastTrigger = null;
      }
    }
  }

  customElements.define('wlsn-info-modal', WLSNInfoModal);
}
